import React from 'react';
import Card from '../components/UI/Card';
import { PageTransition } from '@/components/motion';

function ChartAnalysis() {
  return (
    <PageTransition>
      <div className="p-8">
        <Card title="Chart Analysis">
          <div className="text-center py-20">
            <div className="text-5xl mb-4">📈</div>
            <p className="text-muted-foreground mb-2">Advanced charting coming soon</p>
            <p className="text-sm text-muted-foreground/70">Technical indicators, drawing tools, and multi-symbol comparison.</p>
          </div>
        </Card>
      </div>
    </PageTransition>
  );
}

export default ChartAnalysis;
